import mixpanel from "mixpanel-browser";

const useBundleMixpanelHook = () => {
    function trackEnableCoreSnippet({ cta = "Enable Core Snippet", ctaType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
        };
        console._log("kefiBundles: Enbale Core Snippet", temp);
        mixpanel.track("Enbale Core Snippet", temp);
    }

    function trackHomepageLanding({
        cta = "Homepage Landing",
        freshUser = "-",
        bundleCount = 0,
        ctaType = "Navigation Menu",
    }) {
        const temp = {
            Cta: cta || "-",
            "Fresh User": freshUser,
            "Bundles Count": bundleCount,
            "Cta Type": ctaType || "-",
        };
        console._log("kefiBundles: Homepage Landing", temp);
        mixpanel.track("Homepage Landing", temp);
    }

    function trackAiBundlesLanding({ cta = "AI Bundles Landing" }) {
        const temp = {
            Cta: cta || "-",
        };
        console._log("kefiBundles: AI Bundles Landing", temp);
        mixpanel.track("AI Bundles Landing", temp);
    }

    function trackDesignLanding({ cta = "Design Settings", ctaType = "Navigation Menu" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
        };
        console._log("kefiBundles: Design Settings Landing", temp);
        mixpanel.track("Design Settings Landing", temp);
    }

    function trackOnboardingJourney({ cta = "Onboarding Journey", ctaType = "", screen = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            Screen: screen || "-",
        };
        console._log("kefiBundles: Onboarding Journey", temp);
        mixpanel.track("Onboarding Journey", temp);
    }

    function trackHomepageBrandBanner({ cta = "Homepage Brand Banner", ctaType = "-", url = "-" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Cta URL": url || "-",
        };
        console._log("kefiBundles: Homepage Brand Banner", temp);
        mixpanel.track("Homepage Brand Banner", temp);
    }

    function trackCreateBundles({ cta = "Create Bundles", ctaType = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Create Bundles", temp);
        mixpanel.track("Create Bundles", temp);
    }

    function trackBundleReview({ cta = "Bundle Feedback", ctaType = "Table", bundleCount = 0 }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Total Bundles": bundleCount || "-",
        };
        console._log("kefiBars: Track Review", temp);
        mixpanel.track("Track Review", temp);
    }

    function trackBookSession({ cta = "Book a Session" }) {
        const temp = {
            Cta: cta || "-",
        };
        console._log("kefiBundles: Create Bundles", temp);
        mixpanel.track("Session Bundle", temp);
    }
    function trackFormMenu({ cta = "Form Menu", ctaType = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Form Menu", temp);

        mixpanel.track("Form Menu", temp);
    }
    function trackInspectorModeToggle({
        cta = "Inspector Mode Toggle",
        ctaType = "",
        bundleType,
        inspectorMode,
    }: {
        cta?: string;
        ctaType?: string;
        bundleType: string;
        inspectorMode: boolean;
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType,
            "Inspector Mode": inspectorMode || "-",
        };

        console._log("kefiBundles: Inspector Mode Toggle", temp);

        mixpanel.track("Inspector Mode Toggle", temp);
    }

    function trackFromTabs({ cta = "Form Tabs Switched", tabName = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Tab Name": tabName || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Form Tabs Switched", temp);
        mixpanel.track("Form Tabs Switched", temp);
    }

    function trackDesignFromTabs({ cta = "Design Form Tabs Switched", tabName = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Tab Name": tabName || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Design Form Tabs Switched", temp);
        mixpanel.track("Design Form Tabs Switched", temp);
    }

    function trackFormSections({ cta = "Form Section", ctaType = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Form Section", temp);

        mixpanel.track("Form Interaction", temp);
    }

    function trackBundleDiscount({ cta = "Discount", type = "", value = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Discount Type": type || "-",
            "Discount Value": value || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Form Section", temp);

        mixpanel.track("Form Interaction", temp);
    }

    function trackFormEvents({ cta = "Form Interaction", ctaType = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Form Interaction", temp);

        mixpanel.track("Form Interaction", temp);
    }

    function trackPreviewEvents({ cta = "Preview Interaction", ctaType = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Preview Interaction", temp);

        mixpanel.track("Preview Interaction", temp);
    }

    function trackTargeting({ cta = "Target Form Interaction", targetType = "", value = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Targeting Type": targetType || "-",
            Value: value || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Target Form Interaction", temp);

        mixpanel.track("Target Form Interaction", temp);
    }

    function trackSuggestion({ cta = "Suggestion Card", ctaType = "", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Suggestion Card", temp);

        mixpanel.track("Suggestion Card", temp);
    }

    function trackRemoveBrandRequest({ cta = "Remove Brand Request", ctaType = "Click here", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Remove Brand Request", temp);

        mixpanel.track("Remove Brand Request", temp);
    }

    function trackEmbedCodeCopy({ cta = "Embed Code Copied", ctaType = "Copy", bundleType = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log("kefiBundles: Embed Code Copied", temp);

        mixpanel.track("Embed Code Copied", temp);
    }

    function trackErrorBeforeSave({ cta = "Save", ctaType = "Save", bundleType = "", errors = "" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType ?? "-",
            errors: errors ?? +"-",
        };
        console._log("kefiBundles: Error Before Save", temp);

        mixpanel.track("Error Before Save", temp);
    }

    function trackCtaClick({
        cta = "Default CTA",
        ctaType = "Click",
        bundleType = "",
    }: {
        cta?: string;
        ctaType?: string;
        bundleType?: string;
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "Bundles Type": bundleType || "-",
        };
        console._log(`kefiBundles: ${cta}`, temp);

        mixpanel.track("Action Button CTA", temp);
    }

    function trackPlanSwitchAttempt({
        fromPlan,
        toPlan,
        ctaType = "Click",
    }: {
        fromPlan?: string;
        toPlan?: string;
        ctaType?: string;
    }) {
        const payload = {
            "Current Plan": fromPlan || "-",
            "Clicked Plan": toPlan || "-",
            "CTA Type": ctaType || "Click",
            Source: "Pricing Page",
        };

        console._log("kefiPlans: ", payload);
        mixpanel.track("plan choose", payload);
    }
    function trackKefiLabsLanding({ cta = "Kefi Labs Landing", ctaType = "Navigation Menu" }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
        };
        console._log("kefiBundles: Kefi Labs Landing", temp);
        mixpanel.track("Kefi Labs Landing", temp);
    }

    function trackKefiLabsCta({
        cta = "Kefi Labs CTA",
        ctaType = "Button",
        appId = "",
        appTitle = "",
    }: {
        cta?: string;
        ctaType?: string;
        appId?: string;
        appTitle?: string;
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            "App ID": appId || "-",
            "App Title": appTitle || "-",
        };
        console._log("kefiBundles: Kefi Labs CTA", temp);
        mixpanel.track("Kefi Labs CTA", temp);
    }

    function trackPricingPageVisit() {
        const payload = {
            Source: "Pricing Page",
        };

        console._log("kefiPlans: ", payload);
        mixpanel.track("landed billing page", payload);
    }

    function trackDiscountOnPlan({ modalStatus, code, cta, ctaType, off, type, recurringTime, targetPrice }: any) {
        const temp = {
            Source: "Pricing Page",
            Modal: modalStatus ? "Opened" : "Closed",
            Code: code || "-",
            Off: off || 0,
            CTA: cta || "-",
            "CTA Type": ctaType || "-",
            type: type || "-",
            recurringTime: recurringTime || "Infinite",
            targetPrice: targetPrice || "-",
        };
        console._log("kefiBundles: Plan Discount", temp);
        mixpanel.track("Plan Discount Code", temp);
    }

    function trackCustomPlanContactUsCTA({
        cta = "Default CTA",
        ctaType = "Click",
    }: {
        cta?: string;
        ctaType?: string;
        bundleType?: string;
    }) {
        const temp = {
            Source: "Pricing Page",
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
        };
        mixpanel.track("CUSTOM PLAN CONTACT US CTA", temp);
    }

    return {
        trackEnableCoreSnippet,
        trackHomepageLanding,
        trackDesignLanding,
        trackOnboardingJourney,
        trackHomepageBrandBanner,
        trackCreateBundles,
        trackBookSession,
        trackFormMenu,
        trackFromTabs,
        trackInspectorModeToggle,
        trackDesignFromTabs,
        trackFormSections,
        trackFormEvents,
        trackCtaClick,
        trackPreviewEvents,
        trackTargeting,
        trackSuggestion,
        trackBundleReview,
        trackRemoveBrandRequest,
        trackEmbedCodeCopy,
        trackErrorBeforeSave,
        trackPlanSwitchAttempt,
        trackPricingPageVisit,
        trackDiscountOnPlan,
        trackBundleDiscount,
        trackAiBundlesLanding,
        trackKefiLabsLanding,
        trackKefiLabsCta,
        trackCustomPlanContactUsCTA,
    };
};

export default useBundleMixpanelHook;
